import { SceneWrapper } from '~/components';
import { Markdown, remarkBreaks } from '~/modules';
import { ButtonComponent, ButtonWrapper, Title } from './styles';

interface OnboardingContractProps {
  markdown: string;
  agreeWithContract: () => void;
  backContract: () => void;
}

const OnboardingContract = ({
  markdown,
  agreeWithContract,
  backContract,
}: OnboardingContractProps) => {
  return (
    <SceneWrapper
      footer={
        <ButtonWrapper>
          <ButtonComponent
            id="accept-contract"
            onPress={agreeWithContract}
            fullWidth
          >
            CONCORDAR
          </ButtonComponent>
          <ButtonComponent
            id="back-contract"
            onPress={backContract}
            fullWidth
            transparent
          >
            VOLTAR
          </ButtonComponent>
        </ButtonWrapper>
      }
    >
      <Title>Contrato</Title>
      <Markdown remarkPlugins={[remarkBreaks]}>{markdown}</Markdown>
    </SceneWrapper>
  );
};

export default OnboardingContract;
